import { AgentApi, AgentApiName } from '@/domains/agent/apis'
import type { AgentApiV2 } from '@/domains/agent/apis/agent-api-v2'
import { i18n } from '@/infrastructure/locales'
import { injectNamedService } from '@patsnap/tahiti-core/ioc/inject'
import { Toast } from 'patsnap-biz'
import type { RouteRecordRaw } from 'vue-router';

export const lcaRouterList: RouteRecordRaw[] = [

    {
        path: 'lca/:agent_job_id',
        name: 'ai-ls-lca-detail',
        component: () => import('@/pages/ai-ls/AgentFlowResult.vue'),
        props: () => ({ isSharePage: false }),
        beforeEnter: async(to) => {
            if (to.query.agent !== 'lca_v2') {
                return {
                    path: to.path,
                    query: { ...to.query, agent: 'lca_v2' },
                    replace: true,
                }
            }

            const agentApi = injectNamedService<AgentApiV2>(AgentApi, AgentApiName.V2)
            const { is_owner } = await agentApi.getJobOwnership(to.params.agent_job_id as string)
            if (!is_owner) {
                Toast({
                    message: i18n.global.t('taskAccessDenied'),
                    type: 'error',
                })
                return {
                    name: 'agent-home',
                    query: { agent: 'lca_v2' },
                }
            }

            return true
        },
    },
    {
        path: 'lca/share/:agent_share_id',
        name: 'ai-ls-lca-share-redirect',
        component: () => import('@/pages/ai-ls/LcaShareRedirect.vue'),
    },
    {
        path: 'lca/share/result/:agent_job_id',
        name: 'ai-ls-lca-share-detail',
        component: () => import('@/pages/ai-ls/AgentFlowResult.vue'),
        props: () => ({ isSharePage: true }),
    }
]
